import { render, staticRenderFns } from "./OrderErrorPage.vue?vue&type=template&id=c72f1984"
import script from "./OrderErrorPage.vue?vue&type=script&lang=js"
export * from "./OrderErrorPage.vue?vue&type=script&lang=js"
import style0 from "./OrderErrorPage.vue?vue&type=style&index=0&id=c72f1984&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports